import ActionsPaper from './ActionsPaper'

export default ActionsPaper
